module.exports = __webpack_public_path__ + "static/media/tc.338b9890.webp";